import { IEspClient } from './IEspClient';

export function emailMarketing (client: IEspClient): IEspClient {
    return client;
}
